import { useSelector } from "react-redux";
import { RootState } from "core/src/store/store.types";
import { createSelector } from "@reduxjs/toolkit";

const getNavigationState = (state: RootState) => state.navigation;

const getLocation = createSelector(getNavigationState, (state) => state.location);

export const useNavigationSelectors = () => {
	const location = useSelector(getLocation);

	return {
		location,
	};
};
